import LoginPage from '@/pages/login/login-page/login-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/login')({
  component: LoginPage,
  validateSearch: search => {
    return { redirect: (search.redirect ?? '/') as string };
  },
});
